import { useState, useEffect } from 'react';
import { LOGIN_VARIANTS_ENDPOINT } from '../constants';
import { DynamicVariantProps } from '../interfaces/variant';
import { getDynamicVariant } from '../utils/variant-utils';

export type LoginVariantsHookResponse = {
  loginVariant: DynamicVariantProps | null;
  hasError: boolean;
};

const useLoginVariants = (): LoginVariantsHookResponse => {
  const [loginVariant, setLoginVariant] = useState<DynamicVariantProps | null>(
    null
  );
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const fetchLoginVariants = async (): Promise<void> => {
      try {
        const response = await fetch(LOGIN_VARIANTS_ENDPOINT);
        const data = await response.json();
        setHasError(false);
        setLoginVariant(getDynamicVariant(data));
      } catch (error) {
        setHasError(true);
        throw new Error(`Failed fetching login variants: ${error}`);
      }
    };

    fetchLoginVariants();
  }, []);

  return {
    loginVariant,
    hasError
  };
};

export default useLoginVariants;
